module.exports = "<div class=\"cookie-banner\" ng-class=\"{ 'visible' : visible }\">\n\t<div class=\"container\">\n\t\t<p class=\"text\">\n\t\t\tThis website uses cookies to provide you with a great user experience.\n\t\t\tBy closing this banner, dismissing this banner, by clicking on a link or button on this website, or by continuing to browse this website, <a href=\"#\" ui-sref=\"app.legal.privacy\">you accept our use of cookies.</a>\n\t\t</p>\n\t\t<button class=\"btn btn-default btn-cta\" ng-click=\"acceptCookies($event)\">OK</button>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/cookieBanner/template.html
// module id = 844
// module chunks = 1